<template>
<!-- old primary #329331 -->
  <v-footer app absolute padless max-width="450px"  height="60px"
    style="box-sizing: border-box; background-color: #329331;"
    class="footer-buttons justify-space-around"
  >
    <div v-for="link in links" :key="link.name" 
      :class="{ not_tab: !currentPath(link) && !currentPathYellow(link), current_tab: currentPath(link), current_tab_yellow: currentPathYellow(link) }"
      class="mx-2 flex-grow-1 py-2"
    >
      <router-link v-if="link.name == 'rewards'" 
        :to="{ name: link.name }"
        :active="currentPath(link)"
        class="d-flex flex-column align-center justify-center text-decoration-none white--text"
      >
        <v-icon color="#F7C050">{{ link.icon }}</v-icon>
        <div style="font-size: 10px; color: #F7C050; line-height: 10px;">{{ link.label }}</div>
      </router-link>
      <router-link v-else 
        :to="{ name: link.name }"
        :active="currentPath(link)"
        class="d-flex flex-column align-center justify-center text-decoration-none white--text"
      >
        <v-icon color="white">{{ link.icon }}</v-icon>
        <div style="font-size: 10px; line-height: 10px;">{{ link.label }}</div>
      </router-link>

    </div>
  </v-footer>
</template>

<script>
export default {
  name: "NavFooter",

  data: () => ({
    links: [
      { label: 'Refer', name: 'referrals', path: '/referrals', icon: 'mdi-account-multiple-outline'},
      { label: 'Rewards', name: 'rewards', path: '/rewards', icon: 'mdi-seal'},
      { label: 'Leads', name: 'leads/list', path: '/leads', icon: 'mdi-account-filter-outline'},
      { label: 'Pros', name: 'pros/list', path: '/pros', icon: 'mdi-handshake-outline'},
      { label: 'You', name: 'you', path: '/you', icon: 'mdi-account-box-outline'},
    ],
  }),

  methods: {
    currentPath: function (link) { 
        return link.name != 'rewards' && this.$route.matched.some( r => r.path == link.path )
    },

    currentPathYellow: function (link) { 
        return link.name == 'rewards' && this.$route.matched.some( r => r.path == link.path )
    },
  }
}
</script>

<style lang="scss" scoped>

.footer-buttons {
  border-top: 1px solid grey !important;

  .current_tab {
    border-bottom: 3px solid white;
  }
  .current_tab_yellow {
    border-bottom: 3px solid #F7C050;
  }
  .not_tab {
    border-bottom: 3px solid rgba(0,0,0,0);
  }
}

</style>